<div
  #modalContents
  class="l-modal03__contents js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="sort-condition-modal-title"
>
  <div #modalHead class="l-modal03__header js-modal-head">
    <div class="p-modal-head01">
      <h1 id="modalTitle" class="p-modal-head01__title" [innerHTML]="'label.sortDisplay.title' | staticMsg"></h1>
      <button
        id="sort-condition-modal-close-btn"
        class="p-modal-head01__close js-modal-close"
        (throttleClick$)="this.cancelModal()"
        aswThrottleClick
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody class="l-modal03__body js-modal-body">
    <ul class="c-sort-list">
      <ng-container *ngFor="let item of this.itemList">
        <!-- 選択中 -->
        <li class="c-sort-list__item" [class.c-sort-list__item--selected]="item.value === this.selectedSortCondition">
          <ng-container *ngIf="item.value === this.selectedSortCondition">
            <div id="sort-condition-modal-apply-div" class="c-sort-list__item-btn">
              <span class="c-sort-list__item-text">
                <em [innerHTML]="item.label | staticMsg"></em>
                <img
                  *ngIf="item.value === this.selectedSortCondition"
                  src="assets/images/icon_check_primary_20.svg"
                  width="20"
                  height="20"
                  alt="{{ 'label.selecting' | staticMsg }}"
                />
              </span>
            </div>
          </ng-container>
          <!-- 未選択 -->
          <ng-container *ngIf="item.value !== this.selectedSortCondition">
            <button
              id="sort-condition-modal-apply-btn"
              class="c-sort-list__item-btn"
              (throttleClick$)="this.applyModal(item.value)"
              aswThrottleClick
            >
              <span class="c-sort-list__item-text">
                <em [innerHTML]="item.label | staticMsg"></em>
              </span>
            </button>
          </ng-container>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
